const article = {
	slug: "closing-the-gaap-notebooklm",
	title: "Closing the GAAP: Using AI to Understand Earnings Reports",
	date: "July 2025",
	updated: null,
	description: "A tech leader's approach to using AI as a thinking partner for financial literacy, learning to read earnings reports without an expert on call.",
	keywords: ["financial literacy", "AI thinking partner", "earnings reports", "continuous learning", "NotebookLM"],
	tldr: "AI is no replacement for domain experts, but used right it accelerates learning on dense material. You still have to care enough to ask better questions.",
	readingTime: null,
	provenance: "Adapted from my LinkedIn post, July 2025.",
	provenanceUrl: null,
	series: null,
	artifact: null,
	markdown: `I have a ritual with Mr. P at work.

Every quarter, after our earnings report comes out, I sit with him after work in the office. To understand the big picture of how each business unit at our company makes money and shows their impact.

I always walk away with great insights from Mr. P about how our numbers are trending, what the historical performance is, where the business is growing, and where it is stalling.

His analysis is a masterclass in connecting financial statements to real-world decisions, essential for tech leaders to prioritize money-making projects instead of chasing shiny tech (which I have been guilty of sometimes.)

But I also recognize that it is a privilege and I can't expect him to take time after work. That made me want to get better at this on my own.

## Finding a thinking partner

I tried various summarization tools to break down the jargon. I also used sophisticated prompting techniques to make those concepts stick.

In that process, I came across AI tools built for exactly this kind of dense study. The features I lean on most are the autogenerated deep dive podcasts, with two AI personalities breaking down complex concepts and questioning numbers like I would not have done on my own, and the mindmaps that make it more visual.

I fed it earnings reports from Visa and Mastercard, pairing them with investor calls, mind maps, and podcast transcripts as data sources.

For me, it doesn't just give the answers, but it helps me think with the interactive podcast format. Every response is backed by source references, so we can verify and trace the information directly.

It connects dots between sections, summarizes jargon-heavy paragraphs, and surfaces relationships I might miss in the first few reads.

## Beyond finance

My wife taught me how to read scientific papers to better understand her work. These scientific papers are dense! Denser than the code I try to read or write, and I only hope to get better at it.

This approach has also been invaluable in helping me digest dense scientific papers, where the goal isn't just summarizing but achieving a deeper understanding.

## Still have to ask better questions

This is in no way a replacement for experience and domain knowledge of people like Mr. P. We still have to care enough to ask better questions.`,
};

export default article;
